import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import type { LoadableComponent } from '@townsquare/loadable/types';

import { MilestoneCard_cardQuery$key } from './__generated__/MilestoneCard_cardQuery.graphql';
import { MilestoneProps, MilestoneFormProps } from './types';

export const Milestone: ComponentType<MilestoneProps> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: 'milestone' */ './Milestone'),
	loading: () => null,
});

export const MilestoneForm: ComponentType<MilestoneFormProps> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: 'milestonesForm' */ './MilestonesForm'),
	loading: () => null,
});

export const MilestoneCard: ComponentType<{
	data: MilestoneCard_cardQuery$key;
}> &
	LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: 'milestoneCard' */ './MilestoneCard'),
	loading: () => null,
});
